import moment from 'moment';
import app from '../../../app';
import {
  and,
  questionIsYes,
  visitNumberIs,
  visit2OrVisit6AndQuestionNotEnteredInVisit2
} from "./question-conditions";

const sixMonthsAgo = moment().subtract(6, 'months')

const whenCurrentVersionIsLessThan6 = () => app.store.getters['encounter/versionInt'] < 6

const medicationDSS = [
  {
    key: 'MYOCARDIAL_INFARCTION_12MONTHS',
    display: visitNumberIs(2,6),
    post: visitNumberIs(2,6),
  },
  {
    key: 'HISTORY_ATRIAL_FIBRILLATION',
    display: visitNumberIs(6),
    post: visitNumberIs(6),
  },
  {
    key: 'SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION',
    display: visitNumberIs(6),
    post: visitNumberIs(6),
  },
  {
    key: 'SECOND_VASCULAR_EVENT_2YEARS_ON_STATIN',
    display: visitNumberIs(2,6),
    post: visitNumberIs(2,6),
  },
  {
    key: 'HAD_PCI',
    display: visitNumberIs(6),
    post: visitNumberIs(6),
  },
  {
    key: 'PCI_DATE',
    display: and(
        visitNumberIs(6),
        questionIsYes('HAD_PCI')
    ),
    post: visitNumberIs(6),
  },
  {
    key: 'ALREADY_HIGH_DOSE_STATIN',
    display: visitNumberIs(2,6),
    post: visitNumberIs(2,6),
  },
  {
    key: 'ACEI_INTOLERANCE',
    display: visit2OrVisit6AndQuestionNotEnteredInVisit2('ACEI_INTOLERANCE'),
    post: visit2OrVisit6AndQuestionNotEnteredInVisit2('ACEI_INTOLERANCE'),
  },
  {
    key: 'INTOLERANCE_ASPIRIN',
    display: visit2OrVisit6AndQuestionNotEnteredInVisit2('INTOLERANCE_ASPIRIN'),
    post: visit2OrVisit6AndQuestionNotEnteredInVisit2('INTOLERANCE_ASPIRIN'),
  },
  {
    key: 'INTOLERANCE_STATINS',
    display: visit2OrVisit6AndQuestionNotEnteredInVisit2('INTOLERANCE_STATINS'),
    post: visit2OrVisit6AndQuestionNotEnteredInVisit2('INTOLERANCE_STATINS'),
  },
  {
    key: 'SYSTOLIC_HEART_FAILURE_OR_KIDNEY_DISEASE_OR_LV_DYSFUNCTION',
    display: visitNumberIs(6),
    post: visitNumberIs(6),
  },
];

export default medicationDSS;
